import React from 'react';
import { useTranslation } from 'react-i18next';
import capitalize from 'lodash/capitalize';

import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import Icon from '../../../../../common/general/Icon';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { INFORMED_CONSENT_ITEM_SAVE_FAILED } from '../../../../../constants/notificationMessages';
import { ADD_EDIT_INFORMED_CONSENT_ITEMS } from '../../../../../constants/userOperations';
import { userHasAccessTo } from '../../../../../services/auth';
import { NSPS_STUDY } from '../../../../../services/i18n/namespaces';

import InformedConsentItemModal from './InformedConsentItemModal';

export default function InformedConsentColumn({ label, items, studyId, updateItems }) {
  const { t } = useTranslation(NSPS_STUDY, { keyPrefix: 'informedConsent' });
  return (
    <div className="informed-consent-setup-column">
      <div className="informed-consent-setup-column-header">
        <p className="informed-consent-setup-column-header-text">
          {capitalize(t(`plural.${label}`, { ns: NSPS_STUDY }))}
        </p>
        {userHasAccessTo(ADD_EDIT_INFORMED_CONSENT_ITEMS) && (
          <span className="add-informed-consent-setup-item">
            <Button size="h28" priority="low" onClick={() => openAddModal({ label, studyId, updateItems })}>
              <Icon suit="glyphicon">plus</Icon>
            </Button>
          </span>
        )}
      </div>
      <ul>{items}</ul>
    </div>
  );
}

function openAddModal({ label, studyId, updateItems }) {
  ModalBoxes.open({
    component: <InformedConsentItemModal label={label} studyId={studyId} updateItems={updateItems} />,
    onClose: isChanged => {
      if (isChanged) {
        NotificationManager.error(INFORMED_CONSENT_ITEM_SAVE_FAILED);
      }
    }
  });
}
